<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form ref="formRef" :model="form" label-width="auto" style="margin: auto;max-width: 80%;" size="small"
            :rules="rules">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="规则名称" prop="name">
                        <el-input v-model="form.name" />
                    </el-form-item>
                    <el-form-item label="登录起始时间" prop="user_rules.begin_login_time">
                        <el-date-picker v-model="form.user_rules.begin_login_time" type="date" placeholder="请选择登录起始时间"
                            style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="登录结束时间" prop="user_rules.end_login_time">
                        <el-date-picker v-model="form.user_rules.end_login_time" type="date" placeholder="请选择登录结束时间"
                            style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="注册起始时间" prop="user_rules.begin_register_time">
                        <el-date-picker v-model="form.user_rules.begin_register_time" type="date"
                            placeholder="请选择注册起始时间" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="注册结束时间" prop="user_rules.end_register_time">
                        <el-date-picker v-model="form.user_rules.end_register_time" type="date" placeholder="请选择注册结束时间"
                            style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="手机类型">
                        <el-select v-model="form.user_rules.phone_type" multiple placeholder="请选择手机类型">
                            <el-option label="android" :value="1" />
                            <el-option label="ios" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="国家">
                        <el-select v-model="form.user_rules.country" multiple filterable clearable placeholder="请选择国家">
                            <el-option v-for="(item, index) in countryList" :key="index" :label="item.chinese"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最小APP版本">
                        <el-input v-model="form.user_rules.min_app_version" />
                    </el-form-item>
                    <el-form-item label="最大APP版本">
                        <el-input v-model="form.user_rules.max_app_version" />
                    </el-form-item>
                    <el-form-item label="是否绑定安防设备">
                        <el-select v-model="form.device_rules.device_count_type" placeholder="请选择是否绑定安防设备" clearable>
                            <el-option label="否" :value="1" />
                            <el-option label="是" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否开通云存" v-if="form.device_rules.device_count_type === 2">
                        <el-select v-model="form.subscribe_type" placeholder="请选择是否开通云存" clearable>
                            <el-option label="开通" :value="1" />
                            <el-option label="未开通" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="绑定安防设备型号">
                        <el-select v-model="form.device_rules.device_models" multiple filterable clearable
                            placeholder="请选择绑定安防设备型号">
                            <el-option v-for="(item, index) in modelList" :key="index" :label="item.code"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-switch v-model="form.is_cloud_activity" />
                        <template #label>
                            <span style="font-weight: bold;">云存活动</span>
                        </template>
                    </el-form-item>
                    <el-form-item label="折扣套餐" prop="discount_cloud_info" v-show="form.is_cloud_activity">
                        <el-row v-for="(v, i) in form.discount_cloud_info" :key="i" style="margin-bottom: 8px;">
                            <el-col :span="16">
                                <el-select v-model="v.set_meal_code" placeholder="请选择折扣套餐" filterable
                                    @change="(val) => v.name = packList.find(item => item.SetMeal.code === val).SetMeal.name">
                                    <el-option v-for="(item, index) in packList" :key="index" :label="item.SetMeal.name"
                                        :value="item.SetMeal.code" />
                                </el-select>
                            </el-col>
                            <el-col :span="8" style="display: flex;">
                                <el-input-number v-model="v.discount" :precision="2" :step="0.1" :max="1" :min="0" />
                                <span v-if="i === form.discount_cloud_info.length - 1">
                                    <span
                                        style="font-size: 24px; color: rgb(64, 158, 255); cursor: pointer;margin-right: 2px;margin-left: 8px;"
                                        @click="addPackage">
                                        <i class="el-icon-circle-plus"></i>
                                    </span>
                                    <span style="font-size: 24px; color: #f56c6c; cursor: pointer"
                                        @click="subtractPackage(i)" v-if="form.discount_cloud_info.length > 1">
                                        <i class="el-icon-remove"></i>
                                    </span>
                                </span>
                                <span v-else style="font-size: 24px; color: #f56c6c; margin-left: 8px;cursor: pointer"
                                    @click="subtractPackage(i)">
                                    <i class="el-icon-remove"></i>
                                </span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="是否展示免费试用Banner" v-show="form.is_cloud_activity">
                        <el-select v-model="form.is_show_default" placeholder="" disabled>
                            <el-option label="是" :value="true" />
                            <el-option label="否" :value="false" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="指定用户">
                        <el-input v-model="form.accounts" type="textarea" :rows="3" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit(formRef)">确定</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { reactive, onMounted, ref, watch, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import packApi from '../../../../axios/pack'
import api from '../../../../axios/api'
import { convertDateToTimestamp } from '../../../../util/util'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const form = reactive({
            name: '',
            user_rules: {
                begin_login_time: '',
                end_login_time: '',
                begin_register_time: '',
                end_register_time: '',
                phone_type: '',
                country: '',
                min_app_version: '',
                max_app_version: '',
            },
            device_rules: {
                device_count_type: '',
                device_models: '',
            },
            subscribe_type: '',
            is_cloud_activity: false,
            accounts: '',
            is_show_default: true,
            discount_cloud_info: [{
                discount: '',
                set_meal_code: '',
                name: ''
            }]
        })
        const formRef = ref()
        const packList = ref([])
        const modelList = ref([])
        const countryList = ref([])
        const rules = reactive({
            name: [
                { required: true, message: '规则名称不能为空', trigger: 'blur' }
            ],
            'user_rules.begin_login_time': [
                {
                    validator: (r, v, cb) => {
                        if (form.user_rules.end_login_time && convertDateToTimestamp(v) > convertDateToTimestamp(form.user_rules.end_login_time)) {
                            cb(new Error('登录起始时间不能大于登录结束时间'))
                        } else {
                            cb()
                        }
                    }
                    , trigger: 'blur'
                }
            ],
            'user_rules.end_login_time': [
                {
                    validator: (r, v, cb) => {
                        if (form.user_rules.begin_login_time && convertDateToTimestamp(v) < convertDateToTimestamp(form.user_rules.begin_login_time)) {
                            cb(new Error('登录结束时间不能小于登录起始时间'))
                        } else {
                            cb()
                        }
                    }
                    , trigger: 'blur'
                }
            ],
            'user_rules.begin_register_time': [
                {
                    validator: (r, v, cb) => {
                        if (form.user_rules.end_register_time && convertDateToTimestamp(v) > convertDateToTimestamp(form.user_rules.end_register_time)) {
                            cb(new Error('注册起始时间不能大于注册结束时间'))
                        } else {
                            cb()
                        }
                    }
                    , trigger: 'blur'
                }
            ],
            'user_rules.end_register_time': [
                {
                    validator: (r, v, cb) => {
                        if (form.user_rules.begin_register_time && convertDateToTimestamp(v) < convertDateToTimestamp(form.user_rules.begin_register_time)) {
                            cb(new Error('结注册结束时间不能小于注册起始时间'))
                        } else {
                            cb()
                        }
                    }, trigger: 'blur'
                }
            ]
        })

        // 获取套餐列表
        const getPackList = async () => {
            const res = await packApi.PackageList({
                page: 1,
                limit: 1000,
                kname: '',
                code: '',
                region: '',
                level: '',
                is_event: -1,
                status: JSON.stringify([0, 1]) // 测试、发布
            })
            if (res.data.code == 200) {
                packList.value = res.data.data.data
                return
            }
        }

        // 获取型号列表
        const getModelList = async () => {
            const res = await api.ProductModelList({
                page: 1,
                limit: 1000,
                model: '',
            })
            if (res.data.code == 200) {
                modelList.value = res.data.data.data
                return
            }
        }

        // 获取国家列表
        const getCountryList = async () => {
            const res = await api.CountryList({
                page: 1,
                limit: 500
            })
            if (res.data.code == 200) {
                countryList.value = res.data.data.data
                return
            }
        }

        const addPackage = () => {
            form.discount_cloud_info.push({
                discount: '',
                name: '',
                set_meal_code: ''
            })
        }

        const subtractPackage = (i) => {
            form.discount_cloud_info.splice(i, 1)
        }

        const onSubmit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        console.log('submit!')
                        const toRawForm = JSON.parse(JSON.stringify(toRaw(form)))
                        toRawForm.subscribe_type = Number(toRawForm.subscribe_type)
                        toRawForm.user_rules.begin_login_time = convertDateToTimestamp(toRawForm.user_rules.begin_login_time)
                        toRawForm.user_rules.end_login_time = convertDateToTimestamp(toRawForm.user_rules.end_login_time)
                        toRawForm.user_rules.begin_register_time = convertDateToTimestamp(toRawForm.user_rules.begin_register_time)
                        toRawForm.user_rules.end_register_time = convertDateToTimestamp(toRawForm.user_rules.end_register_time)
                        toRawForm.discount_cloud_info = toRawForm.is_cloud_activity ? JSON.stringify(toRawForm.discount_cloud_info) : JSON.stringify([])
                        toRawForm.user_rules = JSON.stringify(toRawForm.user_rules)
                        toRawForm.device_rules.device_count_type = Number(toRawForm.device_rules.device_count_type)
                        toRawForm.device_rules = JSON.stringify(toRawForm.device_rules)
                        toRawForm.accounts = toRawForm.accounts.length > 0 ? JSON.stringify(toRawForm.accounts.split(',')) : JSON.stringify([])
                        console.log('toRawForm --> ', toRawForm)
                        const res = await api.ContentManageRuleAdd(toRawForm)
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            router.go(-1)
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const goback = () => {
            router.go(-1)
        }

        const checkDiscountCloudInfo = (rule, value, callback) => {
            let isValid = 0
            for (let i = 0; i < value.length; i++) {
                const e = value[i]
                if (!e.discount || !e.set_meal_code || !e.name) {
                    isValid = 1
                }
            }
            if (isValid === 1) {
                callback(new Error("不能为空"))
            } else {
                callback()
            }
        }

        // 观察is_cloud_activity的变化，如果为true，则添加discount_cloud_info, rule校验
        watch(() => form.is_cloud_activity, (val) => {
            if (val) {
                // 向rules中添加一条校验规则
                rules.discount_cloud_info = [
                    { required: true, validator: checkDiscountCloudInfo, trigger: 'blur' }
                ]
                form.is_show_default = false
            } else {
                // 从rules中删除这条校验规则
                delete rules.discount_cloud_info
                form.is_show_default = true
            }
        })

        onMounted(() => {
            getPackList()
            getModelList()
            getCountryList()
            const code = route.params.code
            if (code && code !== '0') {
                api.ContentManageRuleDetail({ code }).then(res => {
                    if (res.data.code === 200) {
                        Object.assign(form, res.data.data)
                        form.subscribe_type = form.subscribe_type ? form.subscribe_type : ''
                        form.device_rules = JSON.parse(form.device_rules)
                        form.device_rules.device_count_type = form.device_rules.device_count_type ? form.device_rules.device_count_type : ''
                        form.user_rules = JSON.parse(form.user_rules)
                        form.user_rules.begin_login_time = form.user_rules.begin_login_time ? new Date(form.user_rules.begin_login_time * 1000) : ''
                        form.user_rules.end_login_time = form.user_rules.end_login_time ? new Date(form.user_rules.end_login_time * 1000) : ''
                        form.user_rules.begin_register_time = form.user_rules.begin_register_time ? new Date(form.user_rules.begin_register_time * 1000) : ''
                        form.user_rules.end_register_time = form.user_rules.end_register_time ? new Date(form.user_rules.end_register_time * 1000) : ''
                        form.discount_cloud_info = JSON.parse(form.discount_cloud_info).length > 0 ? JSON.parse(form.discount_cloud_info) : [{
                            discount: '',
                            set_meal_code: '',
                            name: ''
                        }]
                        form.accounts = JSON.parse(form.accounts).length > 0 ? JSON.parse(form.accounts).join(',') : ''
                    } else {
                        ElMessage.error('获取详情失败: ' + res.data.msg)
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err)
                    ElMessage.error('获取详情失败')
                })
            }
        })

        return {
            form,
            addPackage,
            subtractPackage,
            onSubmit,
            goback,
            packList,
            modelList,
            countryList,
            rules,
            formRef,
            convertDateToTimestamp
        }
    }
}
</script>
